// -1 sinks rows with no usable score instead of letting NaN scramble the sort.
export const effectiveMatchScore = (row, aiEntry) => {
  const n = Number(aiEntry?.aiScore ?? row?.score);
  return Number.isFinite(n) ? n : -1;
};

// Stable: equal scores keep the server's ordering.
export const sortMatchesByScoreDesc = (rows, getAiEntry = () => null) => {
  if (!Array.isArray(rows) || rows.length < 2) return rows;
  return rows
    .map((row, i) => ({ row, i }))
    .sort(
      (a, b) =>
        effectiveMatchScore(b.row, getAiEntry(b.row)) -
          effectiveMatchScore(a.row, getAiEntry(a.row)) || a.i - b.i,
    )
    .map(({ row }) => row);
};
